export default __webpack_public_path__ + "static/media/IMG-2730.e2efbb92.jpg";